<template>
    <div class="row">
        <div class="col-12">
            <div v-html="text" class="block-text"></div>
        </div>
        <div class="col-12 col-sm-6 d-flex align-items-center justify-content-center">
            <b-img :src="image" class="w-100"/>
        </div>
        <div class="col-12 col-sm-6">
            <ul>
                <li v-for="item in list">
                    <h6>{{item.titolo}}</h6>
                    <p>{{item.contenuto}}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "ListWithImageLeft",
    props: {
        header: Object,
        text: String,
        image: String,
        list: Array
    }
}
</script>